export default "/profile/images/echat-logo-text.svg?db67455f9b1dcbae646edb0ba9ac8308";